module.exports = __webpack_public_path__ + "static/media/buildingOff_118.d872baaf.png";